import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiClock, FiMapPin, FiPhone } = FiIcons;

const Home = () => {
  React.useEffect(() => {
    document.title = 'Royal Hooka Lounge - Premium Hookah Experience | Luxury Lounge';
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat hero-overlay"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1544148103-0773bf10d330?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80)'
          }}
        />
        <div className="relative z-10 text-center px-4">
          <motion.h1 
            className="text-5xl md:text-7xl font-serif font-bold text-gold-400 mb-4"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            ROYAL HOOKA
          </motion.h1>
          <motion.p 
            className="text-xl md:text-2xl text-gold-300 mb-8 tracking-wider"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            LUXURY LOUNGE EXPERIENCE
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <Link 
              to="/menu"
              className="inline-block bg-gradient-to-r from-gold-400 to-gold-600 text-black px-8 py-3 rounded-lg font-semibold text-lg hover:from-gold-500 hover:to-gold-700 transition-all duration-300 transform hover:scale-105"
            >
              EXPLORE MENU
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-4">
          <motion.h2 
            className="text-4xl font-serif font-bold text-center text-gold-400 mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Why Choose Royal Hooka
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: FiStar,
                title: 'Premium Quality',
                description: 'We use only the finest tobacco and premium hookah equipment for the best experience.'
              },
              {
                icon: FiClock,
                title: '24/7 Service',
                description: 'Open round the clock to serve you with the best hookah experience anytime.'
              },
              {
                icon: FiMapPin,
                title: 'Prime Location',
                description: 'Located in the heart of the city with easy access and luxurious ambiance.'
              }
            ].map((feature, index) => (
              <motion.div 
                key={index}
                className="text-center p-6 bg-black/50 rounded-lg border border-gold-500/20"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <SafeIcon icon={feature.icon} className="w-12 h-12 text-gold-400 mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-gold-400 mb-3">{feature.title}</h3>
                <p className="text-gray-300">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-gold-600 to-gold-800">
        <div className="container mx-auto px-4 text-center">
          <motion.h2 
            className="text-4xl font-serif font-bold text-black mb-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Ready for a Royal Experience?
          </motion.h2>
          <motion.p 
            className="text-xl text-black mb-8"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Visit us today and indulge in the finest hookah experience
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <Link 
              to="/contact"
              className="inline-block bg-black text-gold-400 px-8 py-3 rounded-lg font-semibold text-lg hover:bg-gray-800 transition-all duration-300 transform hover:scale-105"
            >
              GET DIRECTIONS
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;